import { memo } from "react";

const AdsterraBanner468x60 = memo(() => {
  return (
    <div className="w-full py-4 flex flex-col items-center justify-center bg-muted/10 border-y border-border/40">
      <div
        className="flex items-center justify-center overflow-hidden"
        style={{ width: "468px", maxWidth: "100%", height: "60px" }}
      >
        <iframe
          title="Sponsored Advertisement"
          srcDoc={`<!DOCTYPE html>
<html>
<head>
  <meta charset="utf-8">
  <style>
    body {
      margin: 0;
      padding: 0;
      display: flex;
      justify-content: center;
      align-items: center;
      background: transparent;
      overflow: hidden;
    }
  </style>
</head>
<body>
  <script type="text/javascript">
    atOptions = {
      'key' : '5e6f52569f291eb261afe4226741f4d3',
      'format' : 'iframe',
      'height' : 60,
      'width' : 468,
      'params' : {}
    };
  </script>
  <script type="text/javascript" src="https://www.highrevenueformat.com/5e6f52569f291eb261afe4226741f4d3/invoke.js"></script>
</body>
</html>`}
          width="468"
          height="60"
          style={{ border: "none", overflow: "hidden" }}
          scrolling="no"
        />
      </div>
    </div>
  );
});

export default AdsterraBanner468x60;
